import { TENANTS } from "../../../constants"
import { getCountryFromLanguage } from "../../../core/service/BusinessLogicService"
import { withPackContext } from "../../hoc/withPackContext"
import { withTunnelDataContext } from "../../hoc/withTunnelDataContext"
import Pack from "./Pack"
import StaticComponent from "./StaticComponent"
import React, { useEffect, useMemo } from "react"
import { Row } from "react-bootstrap"

const PackSelect = ({ tunnelData, setTunnelData, setSelectedPack, packContext }) => {
  const { packs, duration } = packContext
  const packsByDuration = useMemo(() => extractPacksByDuration(packs, duration), [packs, duration])
  const cheapestPackPrice = useMemo(() => extractCheapestPackPrice(packsByDuration), [packsByDuration])
  const country = useMemo(
    () => getCountryFromLanguage(tunnelData?.data?.order?.orderLanguageTag || tunnelData?.lang),
    [tunnelData]
  )

  useEffect(() => {
    if (duration) {
      selectPack(packsByDuration[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duration])

  const selectPack = (option) => {
    setSelectedPack(option)
    setTunnelData({
      data: {
        ...tunnelData.data,
        order: {
          ...tunnelData.data.order,
          selectedServicePack: option?.servicePackDTO,
          rent: option?.rentDTO
        }
      }
    })
  }

  if (tunnelData?.tenant === TENANTS.SAMSUNG_IT && country === "IT" && packs?.length <= 1) {
    return <StaticComponent />
  }

  return (
    <Row className="services-row">
      {packsByDuration?.map((pack, index) => (
        <Pack
          option={pack}
          cheapestPackPrice={cheapestPackPrice}
          selectPack={selectPack}
          key={pack?.servicePackDTO?.name + index}
        />
      ))}
    </Row>
  )
}

const extractPacksByDuration = (packs, duration) => {
  return packs && duration
    ? packs.reduce((packsByDuration, pack) => {
        if (pack.rentDTO.duration === duration) {
          packsByDuration.push(pack)
        }
        return packsByDuration.sort((pack1, pack2) => pack1.rentDTO.monthlyTotal - pack2.rentDTO.monthlyTotal)
      }, [])
    : []
}

const extractCheapestPackPrice = (packs) => {
  return packs.length > 0 && packs[0].rentDTO.monthlyTotal
}

export default withTunnelDataContext(withPackContext(PackSelect))
